export class LogicalStreamType {
    _dictionaryType;
    _offsetType;
    _lengthType;
    constructor(_dictionaryType, _offsetType, _lengthType) {
        this._dictionaryType = _dictionaryType;
        this._offsetType = _offsetType;
        this._lengthType = _lengthType;
    }
    get dictionaryType() {
        return this._dictionaryType;
    }
    get offsetType() {
        return this._offsetType;
    }
    get lengthType() {
        return this._lengthType;
    }
}
//# sourceMappingURL=logicalStreamType.js.map